module.exports = __webpack_public_path__ + "img/jycn.4396cfd5.png";